
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import vuescroll from 'vuescroll'
import { mapState } from 'vuex'
import { today } from '@/assets/scripts/utils'
export default {
name: 'info',
props: [],
components: {
XHeader,
Group,
Cell,
XButton,
'scroller': vuescroll
},
data () {
return {
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
userPicture: require('@/assets/sass/images/default.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/default.png') + '"',
extendInfo: [],
personalInfo: [],
familyInfo: [],
isAdd: true,
country: [],
nation: [],
politicsStatus: [],
identity: [],
userInfo: this.$store.state.userInfo,
isShow: true,
toDay: today('YYYY-MM-DD')
}
},
computed: {
...mapState({
title: state => state.currentProcedureInfo.name,
flowId: state => state.flowInfo.flowId,
currentProcedureInfo: state => state.currentProcedureInfo,
procedureId: state => state.currentProcedureInfo.procedureId,
parentRouter: state => state.currentProcedureInfo.parentRouter
})
},
created () {
this.getFlowProcedureStatus()
this.getStudent()
this.getExtendInfo()
this.getFamilyInfo()
},
mounted () {
if (this.token && this.userInfo.studentPictureUrl !== null) {
this.userPicture = this.userInfo.studentPictureUrl
}
if (this.currentProcedureInfo.endDate < this.toDay) {
this.isShow = false
} else {
this.isShow = true
}
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},
finish () {
setTimeout(() => {
this.$router.push({
name: this.parentRouter
})
}, 300)
},

getFlowProcedureStatus () {
let params = {
'procedureBean.id': this.procedureId,
'studentBean.id': this.$store.state.userInfo.id,
'flowBean.id': this.flowId
}
this.$api.get('/dataManagement', params, r => {
let data = r.data
if (data.status === 4) {
this.isAdd = false
} else {
this.isAdd = true
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
getStudent () {
let params = {
account: this.$store.state.userInfo.account
}
this.$api.get('/student', params, r => {
let data = r.data[0]
this.userInfo = data
this.getInfoList()
this.$store.dispatch('userInfoAction', data)
})
},

getExtendInfo () {
let params = {
tableName: 'V_USER_STUDENT',
resourceId: this.userInfo.id
}
this.$api.get('/extendInfo', params, r => {
this.extendInfo = r.data
})
},

getInfoList () {
this.$vux.loading.show()
let params = {
flowId: this.flowId,
flowProcedureId: this.currentProcedureInfo.flowProcedureId,
procedureId: this.procedureId
}
this.$api.get('/studentInfo/config', params,
r => {
this.$vux.loading.hide()
let data = r.data
let baseInfo = []
let extendInfo = []

data.baseFeildList.forEach(element => {
if (element === 'academyCode') {
element = 'academyName'
} else if (element === 'departmentCode') {
element = 'departmentName'
} else if (element === 'professionCode') {
element = 'professionName'
} else if (element === 'classCode') {
element = 'className'
} else if (element === 'campusCode') {
element = 'campusName'
}
let obj = {
name: element,
comments: this.switchName(element),
value: this.userInfo[element]
}
if (element === 'countryCode') {
this.$set(obj, 'value', this.userInfo.standardCountryBean.name)
} else if (element === 'nationCode') {
this.$set(obj, 'value', this.userInfo.standardNationBean.name)
} else if (element === 'politicsStatusCode') {
this.$set(obj, 'value', this.userInfo.standardPoliticsStatusBean ? this.userInfo.standardPoliticsStatusBean.name : null)
} else if (element === 'identityCode') {
this.$set(obj, 'value', this.userInfo.baseIdentityBean.name)
}
if (element === 'sex') {
if (obj.value === 2) {
this.$set(obj, 'value', '女')
} else if (obj.value === 1) {
this.$set(obj, 'value', '男')
}
}
baseInfo.push(obj)
})

data.extendFeildList.forEach(element => {
let obj = {}
for (var i = 0; i < this.extendInfo.length; i++) {
if (element === this.extendInfo[i].tableField) {
obj = {
name: element,
comments: this.extendInfo[i].extendFieldBean.name,
value: this.extendInfo[i].value
}
}
}
extendInfo.push(obj)
})
this.personalInfo = baseInfo.concat(extendInfo)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
switchName (name) {
switch (name) {
case 'name':
return '姓名'
case 'account':
return '账号'
case 'sno':
return '学号'
case 'idNumber':
return '身份证号'
case 'cardId':
return '一卡通号'
case 'cardAccount':
return '卡账号'
case 'examNumber':
return '准考证号'
case 'sex':
return '性别'
case 'birthdate':
return '出生日期'
case 'countryCode':
return '国籍'
case 'nationCode':
return '民族'
case 'politicsStatusCode':
return '政治面貌'
case 'identityCode':
return '身份类型'
case 'campusName':
return '校区'
case 'grade':
return '年级'
case 'academyName':
return '书院'
case 'departmentName':
return '学院'
case 'professionName':
return '专业'
case 'className':
return '班级'
case 'phoneNumber':
return '联系电话'
case 'email':
return '邮箱'
case 'qq':
return 'QQ'
case 'wechat':
return '微信'
case 'origin':
return '生源地'
}
},

getFamilyInfo () {
this.$vux.loading.show()
let params = {
studentId: this.userInfo.id
}
this.$api.get('/family', params, r => {
this.$vux.loading.hide()
let data = r.data
this.familyInfo = data
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/info.vue